import student1 from '../assets/students/student-1.png';
import student2 from '../assets/students/student-2.png';
import student3 from '../assets/students/student-3.png';
import target from '../assets/format/target.svg'
import team from '../assets/format/team.svg'
import snowflake from '../assets/format/snowflake.svg'

/* Секция "Формат и Участие" */
export function Format() {
    return (
        < section className = "format" id = "format" >
            <div className="container">
                <h2 className="section-title scroll-reveal">Формат</h2>
                <div className="format-cards scroll-reveal">
                    <div className="format-wrapper">
                        <img src={student1} alt={'student1'} className="format-image" />
                        <div className="format-card">
                            <img src={target} alt="target" />
                            <h3 className="format-card-title">Основная цель участников</h3>
                            <p className="format-card-text">
                                Разработать ИИ-сервис для генерации перфоманса: изображений и анимаций на трибуны для ПФК ЦСКА
                            </p>
                        </div>
                    </div>
                    <div className="format-wrapper">
                        <div className="format-card">
                            <img src={team} alt="team" />
                            <h3 className="format-card-title">Команды</h3>
                            <p className="format-card-text">
                                Работа над кейсами происходит в командах из 4 человек.
                            </p>
                        </div>
                        <img src={student2} alt={'student2'} className="format-image" />
                    </div>
                    <div className="format-wrapper">
                        <img src={student3} alt={'student3'} className="format-image" />
                        <div className="format-card">
                            <img src={snowflake} alt="snowflake" />
                            <h3 className="format-card-title">Для кого</h3>
                            <p className="format-card-text">
                                Вайбатон подойдёт студентам ИТ и экономических направлений, у которых есть интерес к вайб-кодингу
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section >
    )
}